<template lang="pug">
div(v-if="car")
    v-row(justify="center")
      v-col(cols=8)
        v-radio-group(v-model="carMode")
          v-radio(
            label="Use one of our EVs",
            value="carMode",
            v-if="cars.length > 0"
          )
          v-radio(label="Use a specific Make and Model", value="modelMode")
          v-radio(label="From my garage", value="garageMode", v-if="$user.email")
    v-card-text
      v-autocomplete(
        v-if="carMode == 'modelMode'",
        v-model="car",
        :items="models",
        label="Choose your car",
        :item-text="(item) => item.Name",
        solo,
        return-object,
        @change="updateSelected",
        attach
      )
      v-autocomplete(
        v-if="carMode == 'carMode'",
        v-model="car",
        :items="cars",
        label="Choose your car",
        :item-text="(item) => item.Name",
        solo,
        return-object,
        @change="updateSelected",
        attach
      )
      v-autocomplete(
        v-if="carMode == 'garageMode'",
        v-model="car",
        :items="myCars",
        label="Choose your car",
        :item-text="(item) => item.savedName ? item.savedName : item.name",
        solo,
        return-object,
        @change="updateSelected",
        attach
      )
      v-text-field(
        number,
        v-model.number="car.Year",
        label="Year",
        :disabled="carMode == 'carMode'"
      )
      v-btn(
        v-if="$user && carMode == 'modelMode' && car.ID",
        @click="newProfile"
      ) Add to my Garage
      v-img.white--text.align-end(
        v-if="carMode == 'carMode'",
        :src="car && car.Image ? (car.Image.startsWith('https://') ? car.Image : 'https://powersell.appstack.me/' + car.Image) : '/car_images/No_Image_Powersell.png'",
        height="30vh"
      )
</template>

<script>
export default {
    props: ["selectedCar", "models", "driver"],
    data() {
        return {
            car: null,
            carMode: ""
        }
    },
    methods: {
            updateSelected() {

      let d = new Date();
      let y = d.getFullYear();

      if (this.carMode == "garageMode") {
        this.activeID = this.car.ID;
        this.driver.battery = this.car.currentCharge * 100;
        this.driver.extraWeight = this.car.extraWeight;
        this.driver.passengers = this.car.numberOfPassengers;
        this.driver.batteryMax = this.car.maxCharge;
        this.driver.batteryMin = this.car.minCharge;
        this.driver.sa = this.car.speed;
        this.driver.soh = this.car.stateOfHealth * 100;
        this.driver.aa = this.car.drivingStyle * 10;
      } else {
        this.driver.soh = (1 - (y - this.car.Year) * 0.035) * 100;
        this.activeID = 0;
      }
      this.car.Year = this.car.year;

            this.$emit("updateSelected", this.car);
    },
    },
    mounted() {
    console.log(this.cars);
    this.car = this.selectedCar ? this.selectedCar : this.cars[0];
    if (this.car.year && ! this.car.Year) {
      this.car.Year = this.car.year;
    }
    this.carMode =
      this.cars && this.cars.length > 0
        ? "carMode"
        : this.myCars && this.myCars.length > 0
        ? "garageMode"
        : "modelMode";
    },
      computed: {
    myCars() {
      console.log(this.cars);
      console.log(this.$user);
      if (this.$user){
        return this.$user.driverProfiles;
     } else {
        return [];
      }
    }
      },
      watch: {
          selectedCar: function(val){
              console.log("WATCHING THIS");
              this.car = val;
          }
      }
}
</script>